import { Type } from 'typebox';

/* Stable codes shared by the platform, the twin model and every client (GLOSSARY.md, "Place code").
 * A code is assigned once and never reused; renaming a place keeps its code. */

export const ORGANIZATION_CODE_PATTERN = '^T[0-9]{4}$';
export const BUILDING_CODE_PATTERN = '^B[0-9]{4}$';
export const PLACE_CODE_PATTERN = '^[A-Z][A-Z0-9-]{1,39}$';

export const OrganizationCode = Type.String({ pattern: ORGANIZATION_CODE_PATTERN, examples: ['T0001'] });
export const BuildingCode = Type.String({ pattern: BUILDING_CODE_PATTERN, examples: ['B0002'] });
export const PlaceCode = Type.String({ pattern: PLACE_CODE_PATTERN, examples: ['B0002-F06-MR003'] });
export const Uuid = Type.String({ format: 'uuid' });
export const Timestamp = Type.String({ format: 'date-time' });
/** A timestamp in a response: the server hands a Date, the wire carries an ISO 8601 string. */
export const TimestampOut = Type.Unsafe<Date | string>({ type: 'string', format: 'date-time' });

const organizationCode = new RegExp(ORGANIZATION_CODE_PATTERN);
const buildingCode = new RegExp(BUILDING_CODE_PATTERN);
const placeCode = new RegExp(PLACE_CODE_PATTERN);

export const isOrganizationCode = (value: string): boolean => organizationCode.test(value);
export const isBuildingCode = (value: string): boolean => buildingCode.test(value);
export const isPlaceCode = (value: string): boolean => placeCode.test(value);
